import { render, staticRenderFns } from "./EngagementTaskClientView.vue?vue&type=template&id=2b561040&"
import script from "./EngagementTaskClientView.vue?vue&type=script&lang=js&"
export * from "./EngagementTaskClientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports